/** Utils for working with text */

export const getStringSizes = (text, font, size) => {
  const measurer = document.createElement("span");

  /** set styles */
  measurer.innerText = text;
  measurer.style.fontFamily = font;
  measurer.style.fontSize = size + "px";
  measurer.style.opacity = "0";
  measurer.style.position = "fixed";

  /** append to body */
  document.body.appendChild(measurer);

  /** get width */
  const width = measurer.offsetWidth;
  const height = measurer.offsetHeight;

  /** delete measurer after calculating */
  measurer.remove();

  return { width, height };
};
